// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import sleep from "@insite/client-framework/Common/Sleep";
import { addToStartOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadLists,
} from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";

/**
* @param props
* @constructor
*
* XNG-Changes HSP-845
* extend api parameter filter
*/
export const ExtendApiParameter = (props: any) => {
    const state = props.getState();
    // eslint-disable-next-line prefer-const
    let getWishListsParameter = { ...state.components.addToListModal.getWishListsParameter }
    if (!getWishListsParameter.filter.includes("excludeSpecialLists")) {
        getWishListsParameter.filter = `${getWishListsParameter.filter},excludeSpecialLists`;
    }
    props.dispatch({
        type: "Components/AddToListModal/UpdateGetWishListsParameter",
        parameter: getWishListsParameter,
    });
};

/**
 * @param props
 * @constructor
 *
 * XNG-Changes RUG-1452 OOTB - Spire v5.0.18.875
 * make `getWishListsDataView` read state from Props instead of state variable
 */
export const XngLoadLists = async (props: any) => {
    const state = props.getState();
    const getWishListsParameter = state.components.addToListModal.getWishListsParameter;
    const session = state.context.session;
    if (
        props.parameter.modalIsOpen &&
        (session.isAuthenticated || session.rememberMe) &&
        !getWishListsDataView(state, getWishListsParameter).value
    ) {
        props.dispatch(loadWishLists(getWishListsParameter));

        for (let x = 0; x < 200; x += 1) {
            // XNG-Changes: replace state to props.getState()
            if (getWishListsDataView(props.getState(), getWishListsParameter).value) {
                break;
            }
            await sleep(50);
        }
    }
};

addToStartOfChain(chain, ExtendApiParameter);
replaceInChain(chain, LoadLists, XngLoadLists);
